import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-8 md:py-12">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ChevronLeft className="w-4 h-4 mr-1" />
          Voltar
        </Link>

        <div className="prose prose-invert max-w-none">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
            Termos de Utilização
          </h1>
          <p className="text-muted-foreground mb-8">
            Última atualização: 13 de Abril de 2026
          </p>

          <div className="space-y-8 text-muted-foreground">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">1. Aceitação dos Termos</h2>
              <p>
                Ao aceder e utilizar a plataforma Intimate.pt ("Plataforma"), concorda em ficar vinculado 
                a estes Termos de Utilização. Se não concordar com alguma parte destes termos, não deverá 
                utilizar a nossa Plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">2. Restrição de Idade</h2>
              <p>
                <strong className="text-foreground">A Plataforma destina-se exclusivamente a utilizadores 
                maiores de 18 anos.</strong> Ao utilizar este serviço, declara e garante que:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Tem pelo menos 18 anos de idade</li>
                <li>Tem capacidade legal para celebrar contratos vinculativos</li>
                <li>A visualização de conteúdo para adultos é legal na tua jurisdição</li>
                <li>Não permitirá que menores acedam à tua conta ou dispositivo quando a Plataforma estiver em uso</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">3. Descrição do Serviço</h2>
              <p>
                O Intimate.pt é uma plataforma digital de leitura que disponibiliza conteúdo literário 
                erótico para adultos, incluindo contos, séries e outros materiais escritos. Os serviços 
                incluem:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Acesso a conteúdo gratuito e premium</li>
                <li>Sistema de favoritos e histórico de leitura</li>
                <li>Publicação de conteúdo por autores registados</li>
                <li>Sistema de comentários e avaliações</li>
                <li>Canais de comunicação e confissões anónimas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">4. Registo e Conta</h2>
              <p>
                Para aceder a determinadas funcionalidades, deverá criar uma conta. Ao fazê-lo, compromete-se a:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Fornecer informações verdadeiras e completas</li>
                <li>Manter a confidencialidade da tua palavra-passe</li>
                <li>Notificar-nos imediatamente de qualquer uso não autorizado</li>
                <li>Ser responsável por todas as atividades realizadas na tua conta</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">5. Conteúdo do Utilizador</h2>
              <p>
                Ao submeter conteúdo na Plataforma (contos, comentários, confissões), concede-nos uma 
                licença não exclusiva, mundial, livre de royalties para usar, reproduzir, modificar e 
                exibir esse conteúdo.
              </p>
              <p className="mt-3">
                <strong className="text-foreground">É estritamente proibido publicar conteúdo que:</strong>
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Envolva menores de qualquer forma</li>
                <li>Promova violência real ou não consentida</li>
                <li>Viole direitos de autor de terceiros</li>
                <li>Contenha informações pessoais de terceiros sem consentimento</li>
                <li>Seja ilegal na tua jurisdição ou na nossa</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">6. Conduta do Utilizador</h2>
              <p>Ao utilizar a Plataforma, concorda em não:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Violar qualquer lei aplicável</li>
                <li>Assediar, ameaçar ou intimidar outros utilizadores</li>
                <li>Utilizar a Plataforma para fins comerciais não autorizados</li>
                <li>Tentar aceder a áreas restritas do sistema</li>
                <li>Distribuir malware ou código malicioso</li>
                <li>Criar múltiplas contas para contornar restrições</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">7. Conteúdo Premium e Pagamentos</h2>
              <p>
                Alguns conteúdos podem requerer pagamento. Os pagamentos são processados através de 
                parceiros terceiros. Ao efetuar uma compra:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Concorda com os termos do processador de pagamento</li>
                <li>Reconhece que os reembolsos estão sujeitos à nossa política de reembolsos</li>
                <li>O acesso ao conteúdo premium é pessoal e intransmissível</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">8. Propriedade Intelectual</h2>
              <p>
                Todo o conteúdo da Plataforma, excluindo o conteúdo gerado por utilizadores, é 
                propriedade do Intimate.pt ou dos seus licenciadores. Isto inclui, mas não se limita a:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Design e layout da Plataforma</li>
                <li>Logótipos e marcas</li>
                <li>Software e código</li>
                <li>Textos, gráficos e imagens originais</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">9. Limitação de Responsabilidade</h2>
              <p>
                A Plataforma é fornecida "tal como está". Não garantimos que o serviço será ininterrupto 
                ou livre de erros. Em nenhuma circunstância seremos responsáveis por:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Danos indiretos, incidentais ou consequenciais</li>
                <li>Perda de dados ou lucros</li>
                <li>Conteúdo publicado por utilizadores</li>
                <li>Ações de terceiros</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">10. Suspensão e Rescisão</h2>
              <p>
                Reservamo-nos o direito de suspender ou terminar a tua conta, sem aviso prévio, se:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Violar estes Termos de Utilização</li>
                <li>Fornecer informações falsas</li>
                <li>Participar em atividades fraudulentas</li>
                <li>Por qualquer outro motivo, a nosso exclusivo critério</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">11. Alterações aos Termos</h2>
              <p>
                Podemos modificar estes termos a qualquer momento. As alterações entram em vigor 
                imediatamente após a publicação. O uso continuado da Plataforma após alterações 
                constitui aceitação dos novos termos.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">12. Lei Aplicável</h2>
              <p>
                Estes termos são regidos pela legislação portuguesa. Qualquer litígio será submetido 
                aos tribunais competentes em Portugal.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">13. Contacto</h2>
              <p>
                Para questões relacionadas com estes Termos de Utilização, contacte-nos através de:
              </p>
              <p className="mt-3">
                <strong className="text-foreground">Email:</strong> geral@pimentadocelingerie.pt
              </p>
            </section>
          </div>

          {/* Related Links */}
          <div className="mt-12 pt-8 border-t border-border">
            <h3 className="text-lg font-semibold text-foreground mb-4">Documentos Relacionados</h3>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/privacy" 
                className="text-ruby hover:underline"
              >
                Política de Privacidade
              </Link>
              <Link 
                to="/cookies" 
                className="text-ruby hover:underline"
              >
                Política de Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
